// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fe785b44","455":"ab9bce95","977":"9c52f65e"}[chunkId] + ".chunk.js";
};